import { Link } from "react-router-dom";

/**
 * Gold buttons used site-wide. Two visual variants: solid (primary) and outline.
 * `to` makes it render as a <Link>; otherwise renders as a <button>.
 */
export default function GoldButton({
    children,
    to,
    href,
    variant = "solid",
    className = "",
    onClick,
    testId,
    ...rest
}) {
    const classes =
        variant === "outline" ? "btn-gold-outline" : "btn-gold";
    const merged = `${classes} ${className}`;

    if (to) {
        return (
            <Link
                to={to}
                className={merged}
                data-testid={testId}
                onClick={onClick}
                {...rest}
            >
                {children}
            </Link>
        );
    }
    if (href) {
        return (
            <a
                href={href}
                className={merged}
                data-testid={testId}
                onClick={onClick}
                {...rest}
            >
                {children}
            </a>
        );
    }
    return (
        <button
            type="button"
            onClick={onClick}
            className={merged}
            data-testid={testId}
            {...rest}
        >
            {children}
        </button>
    );
}
